import React from 'react'
import { RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { getMaskDisplayName } from '../utils/utils'

const MaskRecommendationRadioButton = ({ maskName, checked, handleChange, color, disabled, label }) => {
  return (
    <RadioGroup value={maskName} onChange={handleChange}>
      <FormControlLabel
        value={maskName}
        control={
          <Radio
            disabled={disabled}
            checked={checked}
            sx={{
              '& .MuiSvgIcon-root': {
                fontSize: 27, // make the radio circle bigger
                color: color,
              },
            }}
          />}
        label={
          label ? label :
            <strong style={{ color: color }}>{getMaskDisplayName(maskName)}</strong>
        }
      />
    </RadioGroup>
  )
}

export default MaskRecommendationRadioButton